<template>
  <!-- user -->
  <div class="add-new-user-template">
    <router-view />
  </div>
  <!-- END:user -->
</template>

<script>
export default {
  name: 'user',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// User.vue?57afcd19